import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Button } from '../Buttons';
import { isEmpty } from 'lodash';

interface MapboxMapProps {
  data: Array<Filter>;
  activeFilter: string;
  setActiveFilter: Function;
  setSelectedPin: Function;
  selectedPin?: Pin;
}

interface Filter {
  title: string;
  id: string;
  data: Array<Pin>;
}

interface Pin {
  name: any;
  geopoint: {
    latitude: number;
    longitude: number;
  };
}

export const MapBoxFilter: React.FunctionComponent<MapboxMapProps> = ({
  data,
  activeFilter,
  setActiveFilter,
  setSelectedPin,
  selectedPin,
}) => {
  const [dropDownVisible, setDropDownVisible] = useState<boolean>(false);
  const [selectedFilterTitle, setSelectedFilterTitle] =
    useState<string>('Restaurants');

  const mapboxDropClass = classNames('mapbox__dropdown', {
    ['mapbox__dropdown--active']: dropDownVisible,
  });

  const mapboxFilterContainerClass = classNames('mapbox__filter-container', {
    ['mapbox__filter-container--active']: dropDownVisible,
  });

  function handleDropdownAppearance() {
    setDropDownVisible(!dropDownVisible);
  }

  function handleFilterClick(filter: Filter) {
    setActiveFilter(filter.id);
    handleDropdownAppearance();
    setSelectedPin();
  }

  useEffect(() => {
    data.map((filter) => {
      if (filter.id === activeFilter) {
        setSelectedFilterTitle(filter.title);
      }
    });
  }, [activeFilter, data]);

  return (
    <div className="mapbox__filter-outer-wrapper">
      {/* dropdown only shown on mobile */}
      <div className={mapboxDropClass}>
        <Button
          title={selectedFilterTitle}
          filled="dark"
          outline="dark"
          type="dropdown"
          onClick={() => handleDropdownAppearance()}
        />
      </div>

      {/*
       * container will be visible/hidden on mobile,
       * depending on state of dropDownVisible,
       * but will always be visible on tablet/desktop
       */}
      <div className={mapboxFilterContainerClass}>
        <ul className="mapbox__filter-list">
          {data.map((filter, key) => {
            return (
              <li key={key} className="mapbox__filter">
                <Button
                  title={filter.title}
                  filled={filter.id === activeFilter ? 'dark' : ''}
                  onClick={() => handleFilterClick(filter)}
                />

                {filter.id === activeFilter && (
                  <div className="mapbox__results-container">
                    <div className="mapbox__results-container__inner">
                      {isEmpty(filter.data) && <p>No data yet</p>}

                      {!isEmpty(filter.data) && (
                        <ul>
                          {filter.data.map((result, i) => {
                            return (
                              <li
                                key={i}
                                className={classNames('mapbox__result', {
                                  ['mapbox__result--active']:
                                    result === selectedPin,
                                })}
                                onClick={() => setSelectedPin(result)}
                              >
                                <span className="mapbox__result__number">
                                  {i + 1}
                                </span>
                                {result.name[0]?.text || '-'}
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </div>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
